import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import classes from "./images.module.scss";
import Loader from "../../../Components/Common/Loader";
import { Modal } from "../../../shared/Modal/Modal";
import { useLeadImagesQuery } from "../../../api/queries/useLeadImagesQuery";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { isObjectInTranslation } from "../../../i18n/utilities";
import {
  getAgelessImageTranslationKey,
  sortAgelessImages,
} from "../../../utilities/agelessAiImages";
import { getPdfUrl, openPdfInNewTab } from "../../../utilities/pdf";

const LeadsImages = ({ match, history }) => {
  const { leadID } = match.params;
  const [selectedImage, setSelectedImage] = useState(null);
  const { data: { images, pdf } = {}, isLoading } = useLeadImagesQuery({
    id: Number(leadID),
  });
  const { tLeads } = useAppTranslation.Leads();

  if (isLoading) return <Loader showLoader={true} isFullWidth />;

  const sortedImages = sortAgelessImages(images || []);
  const pdfUrl = getPdfUrl(pdf);

  const translateLabel = (imageType) => {
    const key = getAgelessImageTranslationKey(imageType);
    const translated = tLeads(key);

    if (translated === key || isObjectInTranslation(translated, key)) {
      return imageType;
    }

    return translated;
  };

  const renderPdfCard = (pdfSource, label = "PDF") => {
    const source = getPdfUrl(pdfSource);

    if (!source) {
      return null;
    }

    return (
      <button
        type="button"
        onClick={() => openPdfInNewTab(source)}
        className={classes.imageCard}
      >
        <span className={`${classes.thumbWrap} ${classes.pdfThumbWrap}`}>
          <span className={classes.pdfMark}>PDF</span>
        </span>
        <span className={classes.imageType}>{label}</span>
      </button>
    );
  };

  return (
    <div id="content">
      <div className="container-fluid content setting-wrapper-leads">
        <div className={classes.leadsImagesContainer}>
          <h1 className={classes.leadsImagesTitle}>
            <button
              className="btn btn-link pull-left go-back go-back-arrow"
              onClick={() => history.goBack()}
            ></button>
            Ageless AI Images
          </h1>
          <div className={classes.leadsImagesGrid}>
            {sortedImages.length === 0 && !pdfUrl && (
              <p className={classes.emptyState}>No images available</p>
            )}
            {sortedImages.map((image, index) => (
              <button
                type="button"
                key={`lead-${leadID}-image-${image.imageType}-${index}`}
                className={classes.imageCard}
                onClick={() => setSelectedImage(image)}
              >
                <span className={classes.thumbWrap}>
                  <img
                    src={image.url}
                    alt={translateLabel(image.imageType)}
                    className={classes.thumb}
                  />
                </span>
                <span className={classes.imageType}>
                  {translateLabel(image.imageType)}
                </span>
              </button>
            ))}
            {pdfUrl && renderPdfCard(pdfUrl)}
          </div>
        </div>
      </div>
      <Modal
        isOpen={Boolean(selectedImage)}
        onClose={() => setSelectedImage(null)}
        size="wide"
        header={
          selectedImage ? (
            <Modal.Title>{translateLabel(selectedImage.imageType)}</Modal.Title>
          ) : null
        }
        contentClassName={classes.previewModalContent}
      >
        {selectedImage && (
          <img
            src={selectedImage.url}
            alt={translateLabel(selectedImage.imageType)}
            className={classes.previewImage}
          />
        )}
      </Modal>
    </div>
  );
};

export default withRouter(LeadsImages);
